var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "#38393D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 3.99998V2.66665C5.33203 2.31302 5.47251 1.97389 5.72256 1.72384C5.9726 1.47379 6.31174 1.33331 6.66536 1.33331H9.33203C9.68565 1.33331 10.0248 1.47379 10.2748 1.72384C10.5249 1.97389 10.6654 2.31302 10.6654 2.66665V3.99998M12.6654 3.99998V13.3333C12.6654 13.6869 12.5249 14.0261 12.2748 14.2761C12.0248 14.5262 11.6857 14.6666 11.332 14.6666H4.66536C4.31174 14.6666 3.9726 14.5262 3.72256 14.2761C3.47251 14.0261 3.33203 13.6869 3.33203 13.3333V3.99998H12.6654Z",
    stroke: "#38393D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 7.33331V11.3333",
    stroke: "#38393D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33203 7.33331V11.3333",
    stroke: "#38393D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.5ad9c74a1d5cbf0f1ae47b8af906920b.svg";
export { ForwardRef as ReactComponent };